import { useQueryClient } from "@tanstack/react-query";
import { getGetProfileQueryKey } from "../generated/hook";

/**
 * Hook utilitaire pour invalider la requête getConnectedUser
 * Utile après une connexion, déconnexion ou toute action qui modifie l'état d'authentification
 */
export const useInvalidateConnectedUser = () => {
  const queryClient = useQueryClient();

  const invalidateConnectedUser = () => {
    queryClient.invalidateQueries({ queryKey: getGetProfileQueryKey() });
  };

  return invalidateConnectedUser;
};
